module.exports = __webpack_public_path__ + "static/media/exit-confirm@2x.584020b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/exit-confirm@2x.png
// module id = 877
// module chunks = 0